import styled from 'styled-components';

// TODO: Remove this after auth refactor.
export const AuthPanelWrap = styled.div`
	margin: auto;
`;
